import { format, formatDistanceToNow, isPast, differenceInDays } from 'date-fns';

export function formatDate(date: string | Date): string {
  return format(new Date(date), 'MMM d, yyyy');
}

export function formatDateTime(date: string | Date): string {
  return format(new Date(date), 'MMM d, yyyy HH:mm');
}

export function formatRelative(date: string | Date): string {
  return formatDistanceToNow(new Date(date), { addSuffix: true });
}

export function isExpired(date: string | Date): boolean {
  return isPast(new Date(date));
}

export function daysUntilExpiry(date: string | Date): number {
  return differenceInDays(new Date(date), new Date());
}

export function getRuntimeLabel(runtime: string): string {
  const labels: Record<string, string> = {
    TEST_30_DAYS: '30-Day Trial',
    ONE_YEAR: '1 Year',
    THREE_YEARS: '3 Years',
    FIVE_YEARS: '5 Years',
  };
  return labels[runtime] || runtime;
}

export function getStatusLabel(status: string): string {
  return status.charAt(0) + status.slice(1).toLowerCase().replace('_', ' ');
}

export function truncate(str: string, length: number): string {
  if (str.length <= length) return str;
  return str.slice(0, length) + '...';
}

export function copyToClipboard(text: string): Promise<void> {
  return navigator.clipboard.writeText(text);
}

export function classNames(...classes: (string | boolean | undefined | null)[]): string {
  return classes.filter(Boolean).join(' ');
}

export function parseJSON<T>(json: string | null | undefined, fallback: T): T {
  if (!json) return fallback;
  try {
    return JSON.parse(json) as T;
  } catch {
    return fallback;
  }
}

export function getHistoryActionLabel(action: string): string {
  const labels: Record<string, string> = {
    CREATED: 'License created',
    EXTENDED: 'License extended',
    REVOKED: 'License revoked',
    SUSPENDED: 'License suspended',
    REACTIVATED: 'License reactivated',
    DEVICE_COUNT_CHANGED: 'Device count changed',
    STATUS_CHANGED: 'Status changed',
    RENEWED: 'License renewed',
    NOTES_UPDATED: 'Notes updated',
    INSTALLATION_DEACTIVATED: 'Installation deactivated',
    INSTALLATION_REACTIVATED: 'Installation reactivated',
    INSTALLATION_DELETED: 'Installation deleted',
  };
  return labels[action] || action;
}

export function getHistoryActionIcon(action: string): { icon: string; color: string } {
  const icons: Record<string, { icon: string; color: string }> = {
    CREATED: { icon: 'plus', color: 'text-green-500' },
    EXTENDED: { icon: 'clock', color: 'text-blue-500' },
    REVOKED: { icon: 'x', color: 'text-red-500' },
    SUSPENDED: { icon: 'pause', color: 'text-yellow-500' },
    REACTIVATED: { icon: 'check', color: 'text-green-500' },
    DEVICE_COUNT_CHANGED: { icon: 'desktop', color: 'text-purple-500' },
    STATUS_CHANGED: { icon: 'switch', color: 'text-blue-500' },
    RENEWED: { icon: 'refresh', color: 'text-green-500' },
    NOTES_UPDATED: { icon: 'pencil', color: 'text-gray-500' },
  };
  return icons[action] || { icon: 'circle', color: 'text-gray-500' };
}
